import { render, staticRenderFns } from "./WimsPulseAlert.vue?vue&type=template&id=361baa89&scoped=true"
import script from "./WimsPulseAlert.vue?vue&type=script&lang=js"
export * from "./WimsPulseAlert.vue?vue&type=script&lang=js"
import style0 from "./WimsPulseAlert.vue?vue&type=style&index=0&id=361baa89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361baa89",
  null
  
)

export default component.exports